(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

    function getOriginalCount(track) {
      return parseInt(track.dataset.logoBarOriginalCount, 10) || track.children.length;
    }

    function setupInfiniteTrack(track) {
      if (track.dataset.logoBarCloned === 'true') return getOriginalCount(track);

      const originals = [...track.children];
      const count = originals.length;
      if (count <= 1) {
        track.dataset.logoBarOriginalCount = count;
        return count;
      }

      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('logo-bar__item--clone');
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });

      track.dataset.logoBarCloned = 'true';
      track.dataset.logoBarOriginalCount = count;
      return count;
    }

    function teardownInfiniteTrack(track) {
      const count = parseInt(track.dataset.logoBarOriginalCount, 10);
      if (!count || track.dataset.logoBarCloned !== 'true') return;

      while (track.children.length > count) {
        track.removeChild(track.lastElementChild);
      }

      delete track.dataset.logoBarCloned;
      delete track.dataset.logoBarOriginalCount;
    }

    function getMiddleIndex(count) {
      if (count <= 0) return 0;
      return Math.floor((count - 1) / 2);
    }

    function scrollToCenter(track, index, behavior = 'smooth') {
      const slide = track.children[index];
      if (!slide) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const target = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;

      track.scrollTo({
        left: Math.min(Math.max(0, target), maxScroll),
        behavior
      });
    }

    function initLogoBarMobile(slider) {
      if (slider.dataset.logoBarMobileInit === 'true') return;
      slider.dataset.logoBarMobileInit = 'true';

      const track = slider.querySelector('.gridy-track');
      if (!track || track.children.length === 0) return;

      const autoplay = slider.dataset.autoplay === 'true';
      const delay = parseInt(slider.dataset.autoplayDelay, 10) || 5000;
      let current = 0;
      let timer = null;
      let isAnimating = false;
      let scrollEndTimer = null;

      const normalizeAfterScroll = () => {
        const count = getOriginalCount(track);
        if (count <= 1) {
          isAnimating = false;
          return;
        }

        if (current >= count) {
          current -= count;
          track.classList.add('logo-bar__track--no-snap');
          scrollToCenter(track, current, 'auto');
          requestAnimationFrame(() => track.classList.remove('logo-bar__track--no-snap'));
        }

        isAnimating = false;
      };

      const onTrackScroll = () => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(normalizeAfterScroll, 450);
      };

      const tick = () => {
        const count = getOriginalCount(track);
        if (count <= 1 || isAnimating) return;

        isAnimating = true;
        current += 1;
        scrollToCenter(track, current);
      };

      const start = () => {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(tick, delay);
      };

      const stop = () => {
        clearInterval(timer);
        clearTimeout(scrollEndTimer);
      };

      const enableMobile = () => {
        if (!MOBILE_MQ.matches) {
          stop();
          track.removeEventListener('scroll', onTrackScroll);
          teardownInfiniteTrack(track);
          isAnimating = false;

          if (slider.dataset.logoBarMobileActive === 'true') {
            slider.dataset.logoBarMobileActive = 'false';
            if (typeof slider.autoplayGridy === 'function' && autoplay) {
              slider.autoplayGridy();
            }
          }
          return;
        }

        slider.dataset.logoBarMobileActive = 'true';

        if (typeof slider.clearAutoplayTimer === 'function') {
          slider.clearAutoplayTimer();
        }

        const count = setupInfiniteTrack(track);
        current = getMiddleIndex(count);
        track.addEventListener('scroll', onTrackScroll);

        requestAnimationFrame(() => {
          scrollToCenter(track, current, 'auto');
          start();
        });
      };

      enableMobile();
      MOBILE_MQ.addEventListener('change', enableMobile);
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', () => {
        if (MOBILE_MQ.matches) start();
      });
    }

    function initAll(root = document) {
      root.querySelectorAll('.section--logo-bar gridy-slider').forEach((slider) => {
        initLogoBarMobile(slider);
      });
    }

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('products-loaded')) return;

      const fetchContainer = this.querySelector('.fetch-container');
      if (fetchContainer?.innerHTML.trim().length) {
        this.classList.add('products-loaded');
        // Cards already in DOM (SSR) — bind hover video in case init ran before this section
        if (typeof window.initBuffCardHoverVideo === 'function') {
          window.initBuffCardHoverVideo(this);
        }
        return;
      }

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          this.classList.add('products-loaded');

          // Re-bind hover-to-play video on async-injected buff-card-product cards
          if (typeof window.initBuffCardHoverVideo === 'function') {
            window.initBuffCardHoverVideo(this);
          }
          // Buff Beauty: hydrate Yotpo star ratings on recommended cards
          if (typeof window.initBuffYotpoCardRatings === 'function') {
            window.initBuffYotpoCardRatings();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
